import React from "react";
import {
  LEGAL_PRIVACY_URL,
  LEGAL_TERMS_URL,
} from "../../utils/legalAcceptance";
import { openLegalLink } from "../../utils/openLegalLink";

/**
 * The single legal + age checkbox that gates every signup method.
 *
 * Unchecked on every mount by design - the client asked for an affirmative act,
 * so nothing here restores a previous tick.
 */
const LegalAgreementCheckbox = ({ checked, onChange, error, id = "legal-agree" }) => (
  <div className="w-full mt-2">
    <label
      htmlFor={id}
      className="flex items-start gap-3 text-left cursor-pointer select-none"
    >
      <input
        id={id}
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        aria-invalid={error ? "true" : undefined}
        className="mt-1 h-5 w-5 flex-shrink-0 cursor-pointer accent-primaryColor"
        style={{ accentColor: "#004C50" }}
      />
      <span className="text-primaryColor text-sm leading-snug font-montserrat">
        {/* Buttons rather than anchors: inside the Flutter shell these have to
            go through the native in-app browser (the one with the X at the top
            left) or the user is stranded on the policy page with no way back.
            openLegalLink falls back to a new tab on the web. preventDefault
            stops the surrounding label from toggling the checkbox. */}
        I agree to the{" "}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openLegalLink("terms_conditions", LEGAL_TERMS_URL);
          }}
          className="underline font-semibold focus:outline-none"
        >
          Terms of Service
        </button>{" "}
        and{" "}
        <button
          type="button"
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            openLegalLink("privacy_policy", LEGAL_PRIVACY_URL);
          }}
          className="underline font-semibold focus:outline-none"
        >
          Privacy Policy
        </button>{" "}
        and confirm that I am at least 16 years old.
      </span>
    </label>

    {error ? (
      <p
        role="alert"
        className="text-red-600 text-xs mt-2 ml-8 text-left font-montserrat"
      >
        {error}
      </p>
    ) : null}
  </div>
);

export default LegalAgreementCheckbox;
